import React, { useContext } from 'react'
import { WorkModel } from '@Entities/work/work'
import './index.scss'
import BasicWorkMetadata from '@Components/ViewWork/BasicWorkMetadata'
import { ZodFormattedError } from 'zod'
import { StoresContext } from '@App/contexts'
import WritersSection from '@Components/ViewWork/WritersSection'
import PublishersSection from '@Components/ViewWork/PublishersSection'
import { WorkType } from '@Components/ViewWork/work-type'
import RecordingsSection from '@Components/ViewWork/RecordingsSection'
import MatchedRecordingsSection from '@Components/ViewWork/MatchedRecordingsSection'
import calculateTotalKnownShares from '@App/helpers/work-entities/utils/calculate-total-known-shares'

interface ViewWorkProps {
    viewWork: WorkModel
    workType?: WorkType
    editing?: boolean
    myShares?: number
    workErrors?: ZodFormattedError<WorkModel>
    showMatchedRecordings?: boolean
    hideRecordings?: boolean
    matchOnClick?: () => void
}

const ViewWork = (props: ViewWorkProps) => {
    const { rightsholderStore } = useContext(StoresContext)
    const { viewWork, workType, editing, myShares, workErrors, showMatchedRecordings, hideRecordings, matchOnClick } =
        props
    const currentRightsholderId = rightsholderStore.optionalCurrentRightsholderId
    const workId = viewWork.id as number

    return (
        <div className="view-work-wrapper">
            {workType !== 'claim-wizard' && (
                <BasicWorkMetadata
                    viewWork={viewWork}
                    workType={workType}
                    rightsholderId={currentRightsholderId}
                    errors={props?.workErrors}
                    editing={editing}
                />
            )}

            <WritersSection
                writers={viewWork.writers}
                workId={workId}
                rightsholderId={currentRightsholderId}
                editing={editing}
                workType={workType}
                writerErrors={workErrors?.writers}
            />

            <PublishersSection
                publishers={viewWork.originalPublishers}
                workId={workId}
                workType={workType}
                rightsholderId={currentRightsholderId}
                totalKnownShares={calculateTotalKnownShares(viewWork)}
                myShares={myShares}
                editing={editing}
                publisherErrors={workErrors?.originalPublishers}
            />

            {workType !== 'claim-wizard' && !hideRecordings && (
                <>
                    {showMatchedRecordings ? (
                        <MatchedRecordingsSection work={viewWork} matchOnClick={matchOnClick} />
                    ) : (
                        <RecordingsSection
                            work={viewWork}
                            workType={workType}
                            rightsholderId={currentRightsholderId}
                            errors={workErrors?.recordings}
                            editing={editing}
                        />
                    )}
                </>
            )}
        </div>
    )
}

export default ViewWork
